import { GET_PAUSE_OFFER_REWARDS_RESPONSE } from 'actions/pauseOfferRewards';

const initialState = { behavioralDiscounts: [] };

export default (state = initialState, action) => {
  const { response, type } = action;

  switch (type) {
    case GET_PAUSE_OFFER_REWARDS_RESPONSE:
      return { ...state, behavioralDiscounts: response.behavioralDiscounts };
    default:
      return state;
  }
};

const selectPauseOfferRewards = state => state.account.pauseOfferRewards;
export const selectPauseOfferRewardsDisqualifiableBehavioralDiscounts = state =>
  selectPauseOfferRewards(state).behavioralDiscounts;
